import React from 'react';
import CityForm from "./CityForm";
import { breadcrumbsPropTypes } from "../../../common/resource/proptypes/CommonPropTypes";
import PropTypes from "prop-types";
import { CITY_PATH } from "../../../../config/paths";
import { postCity } from "../../../../actions";
import Content from '../../../layout/Content';
import { connect } from 'react-redux';

const NewCity= ({ breadcrumbs, dispatchPostCity }) => {
  const onSubmit = (formValues) => {
    const { name, selectedRegion } = formValues;
    
    const newFormValues = {
      name,
      regionId: selectedRegion.value,
    };
    dispatchPostCity(newFormValues);
  }
    const content = <CityForm onSubmit={onSubmit} />;
    return (
        <Content
          breadcrumbs={breadcrumbs}
          title="Nueva Ciudad"
          subtitle="Crear nueva ciudad"
          content={content}
        />
    );
}

NewCity.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchPostCity: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchPostCity: postCity
};

const mapStateToProps = ({ MechanicalMaintenanceUnit }) => ({
  breadcrumbs: [
    ...MechanicalMaintenanceUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Lista de Ciudades',
      href: CITY_PATH,
    },
    {
      text: 'Nuevo',
      href: '',
    },
  ],
});

export default connect(mapStateToProps, mapDispatchToProps)(NewCity);